import type {DocumentManager, DalItem} from '@wix/document-manager-core'
import type {PageMigrator} from '../dataMigrationRunner'
import type {PageExtensionAPI} from '../../../page'
import type {RelationshipsAPI} from '../../../relationships'
import {VIEW_MODES} from '../../../../constants/constants'
import type {VariantsExtensionAPI} from '../../../variants/variants'
import type {Pointer} from '@wix/document-services-types'

const noRefVariants = ['Preset', 'Hover']

const migratePage = (documentManager: DocumentManager, pageId: string) => {
    if (!documentManager.experimentInstance.isOpen('dm_variantRefOwnerFixer')) {
        return
    }
    const {dal, extensionAPI, pointers} = documentManager
    const {page} = extensionAPI as PageExtensionAPI
    const {relationships} = extensionAPI as RelationshipsAPI

    const getOwningComponentPointer = (componentId: string): {pointer: Pointer; component: DalItem | undefined} => {
        const desktopPointer = pointers.getPointer(componentId, VIEW_MODES.DESKTOP)
        const desktopComponent = dal.get(desktopPointer)
        if (desktopComponent) return {pointer: desktopPointer, component: desktopComponent}

        const mobilePointer = pointers.getPointer(componentId, VIEW_MODES.MOBILE)
        return {pointer: mobilePointer, component: dal.get(mobilePointer)}
    }

    const pageCompFilter = page.getPageIndexId(pageId)
    const dataItemsToCheck: Record<string, DalItem> = dal.query('variants', pageCompFilter, (v: any) =>
        noRefVariants.includes(v.type)
    )
    for (const [id, value] of Object.entries(dataItemsToCheck)) {
        if (!value.componentId) {
            documentManager.logger.interactionStarted('variantHasNoComponentId', {
                ...value,
                id
            })
            continue
        }
        if (relationships.getOwningReferencesToPointer({id, type: 'variants'}).length > 0) continue

        const {pointer: owningComponentPointer, component: owningComponent} = getOwningComponentPointer(
            value.componentId
        )
        if (!owningComponent) continue
        const {variants} = extensionAPI as VariantsExtensionAPI
        variants.addVariantToVariantsList(owningComponentPointer, pointers.getPointer(id, 'variants'))
    }
}

const name = 'variantNoRefOwnerFixer'
const version = 0
const experimentalVersions = [{experiment: 'dm_variantRefOwnerFixer', version: 4}]

export const variantNoRefOwnerFixer: PageMigrator = {
    migratePage,
    name,
    version,
    experimentalVersions
}
